module.exports = __webpack_public_path__ + "29546dbe22300d2aa0c293b8d55df329.svg";